import { formatCurrencyValue } from './currencyFormatters';
import generateMethodKey from './generateMethodKey';

export const getAllFees = (option) =>
  option.locations && option.return_cost
    ? option.locations.reduce(
        (acc, location) =>
          location.return_info && location.return_info.return_cost
            ? {
                shippingFees: [
                  ...acc.shippingFees,
                  location.return_info.return_cost.return_shipping_fee,
                ],
                serviceFees:
                  location.return_info.return_cost.service_fee > 0
                    ? [...acc.serviceFees, location.return_info.return_cost.service_fee]
                    : acc.serviceFees,
              }
            : acc,
        {
          shippingFees: [option.return_cost.return_shipping_fee],
          serviceFees: option.return_cost.service_fee > 0 ? [option.return_cost.service_fee] : [],
        },
      )
    : option.methods.reduce(
        (acc, { return_cost: cost }) => ({
          shippingFees: [...acc.shippingFees, cost.return_shipping_fee],
          serviceFees:
            cost.service_fee > 0 ? [...acc.serviceFees, cost.service_fee] : acc.serviceFees,
        }),
        { shippingFees: [], serviceFees: [] },
      );

export const getFeeTag = ({ option, location, language, locale }) => {
  const methodPriceLabel =
    language[
      `returns.return_options.locations.${generateMethodKey(
        location.return_info.preferred_method_carrier,
      )}.method_price_label`
    ];

  if (methodPriceLabel) return methodPriceLabel;

  const fee = location.return_info.return_cost
    ? location.return_info.return_cost.return_shipping_fee
    : option.return_cost.return_shipping_fee;

  return fee > 0
    ? formatCurrencyValue({ value: fee, locale, currencyCode: option.return_cost.currency_code })
    : language[`returns.return_options.${generateMethodKey(
      location.return_info.preferred_method_carrier,
    )}.free_label`] || language['returns.general.free_label'];
};

export const getReturnMethodsDisplayed = ({
  isAvailableOptionsApi,
  returnOptions,
  returnOptionMethods,
  returnMethods,
}) => {
  if (isAvailableOptionsApi) {
    const methodsDisplayed = new Set();
    returnOptions.forEach(({ locations, methods }) => {
      if (locations && locations.length) {
        locations.forEach((location) => {
          if (location.return_info && location.return_info.preferred_method_carrier) {
            methodsDisplayed.add(generateMethodKey(location.return_info.preferred_method_carrier));
          }
        });
      } else if (methods && methods.length) {
        methods.forEach((method) => methodsDisplayed.add(generateMethodKey(method)));
      }
    });
    return [...methodsDisplayed];
  }

  return Object.keys(returnOptionMethods).length > 0
    ? Object.keys(returnOptionMethods)
    : returnMethods.map(generateMethodKey);
};
